<template>
  <div class="warp">
    <navBox :page="'Explore'"></navBox>
    
    <div class="">

      <Secondary :bgImage="bgImage" :Cntitle="Cntitle" :Entitle="Entitle">
          <template>
            <div  class="custom-layout">

                <div class="paragraph">
                  <div>AI与大数据</div>
                  <div>
                    AI与大数据模型的有效接入平台，为体育赛事的举办、运动员技术水平的提高、俱乐部的发展提供了更多的可能性。
                  </div>
                </div>

                <div class="paragraph">
                  <div>安全保障</div>
                  <div>
                    确保每场赛事资金安全，每一笔订单都可追溯。
                  </div>
                </div>

                <div class="paragraph">
                  <div>赛事直播与互动</div>
                  <div>
                    通过实时直播赛事，扩大比赛影响力。通过分享功能，促进赛事和击剑文化的社区互动。
                  </div>
                </div>

            </div>
        </template>
      </Secondary>

    </div>
  </div>
</template>

<script>
import NavBox from '@/components/navBox.vue';
import Secondary from '../components/secondary.vue';
export default {
  name: 'ExplorePage',
  components:{ Secondary, NavBox },
  data(){
    return{
      Entitle: "EXPLORE",
      Cntitle: "探索多元化业务",
      bgImage:"https://img.fencerspage.com/upload/oss/club/contest/20250317/183167d7dad7273ed.jpg",
    }
  },

  
  methods:{
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$media_num: 1200px;  // 屏幕宽度


.warp {
  margin: 0 auto;
  width: 100vw;
}

.media_box{
  width: 100vw;
  height: 50vw;
  font-size: 0.88vw; //17

  @media only screen and (max-width: $media_num) {
    width: 1200px;
    height:600px;  // 0.5*width
  }
}

.custom-layout{
  font-size: 1.85em;
  letter-spacing: 0.03em;

  .text-indent{
    text-indent: 2em;
  }

  .paragraph{
    padding-bottom: 3em;
    line-height: 1.8em;
  }
}
</style>
